module.exports = __webpack_public_path__ + "img/default-cover.fef3ac2f.png";